/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} TimesheetAddedCommentType
 * @property {string} payOption
 * @property {number} contactId
 * @property {string} contactName
 */

import TimesheetAddedModel from './timesheetAddedModel'

/**
 * @typedef {TimesheetAddedCommentType & TimesheetAddedModel} TimesheetAddedCommentTypeExtended
 */

/**
 * @class
 */
export default class TimesheetAddedComment extends TimesheetAddedModel {
  /**
   * Create a new TimesheetAddedComment.
   * @param {TimesheetAddedCommentTypeExtended} params
   */
  constructor(params) {
    super(params)
    this.payOption = params.payOption
    this.contactId = params.contactId
    this.contactName = params.contactName
  }
}
